import { useMutation } from '@tanstack/react-query';
import { updatePractice } from '../queries/post';

export function useUpdatePractice() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['updatePractice'],
    mutationFn: ({ id, title }: { id: string; title: string }) =>
      updatePractice(id, title),
    retry: false,
  });

  return { mutate, data, isPending, isSuccess };
}
